<template>
  <div class="qualityContain">
    <div class="typeCon">
      <el-radio-group v-model="period" size="medium" @change="periodChange">
        <el-radio-button label="0">摊铺温度</el-radio-button>
        <el-radio-button label="1">摊铺速度</el-radio-button>
        <el-radio-button label="2">摊铺高程</el-radio-button>
        <el-radio-button label="3">平整度</el-radio-button>
        <el-radio-button label="4">效率</el-radio-button>
        <el-radio-button label="5">轨迹</el-radio-button>
      </el-radio-group>
    </div>

    <div class="timeContain" v-if="dateShow">
      <!-- <label class="group-label">时间段</label> -->
      <el-date-picker
        size="medium"
        v-model="duration"
        @change="dateChange"
        type="daterange"
        range-separator="—"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
      <el-button class="searchBtn" type="primary" @click="searchBtn"
        >确认</el-button
      >
    </div>

    <div class="blockHeader" v-if="typeShow">
      <div class="redBlock"></div>
      <div class="headerText">云图</div>
    </div>
    <div class="imgContent" v-if="typeShow">
      <el-button type="primary" class="checkDetail" @click="showDetail"
        >查看详情</el-button
      >
      <RollLegend
        v-show="period == 0"
        class="rollLegend"
        fontColor="black"
        legendType="3"
      ></RollLegend>
      <RollLegend
        v-show="period == 2"
        class="rollLegend"
        fontColor="black"
        legendType="5"
      ></RollLegend>
      <RollLegend
        v-show="period == 3"
        class="rollLegend"
        fontColor="black"
        legendType="6"
      ></RollLegend>
      <el-image
        style="width: 100%; height: 97%"
        :src="imageUrl"
        fit="scale-down"
        :preview-src-list="srcList"
      >
        <div slot="error" class="image-slot">暂无数据</div>
      </el-image>
    </div>
    <div class="blockHeader" v-if="typeShow">
      <div class="redBlock"></div>
      <div class="headerText">数据分析</div>
    </div>
    <div class="infoContain" v-if="typeShow">
      <div class="infoL" v-if="period == 2 ||period == 3">
        <LeftList :data="leftData" :keyMap="keyMap" />
      </div>
      <div class="infoR" v-if="period == 2 ||period == 3">
        <!-- <div class="typeCon">
          <el-radio-group
            v-model="periodNum"
            size="medium"
            @change="periodNumChange"
          >
            <el-radio-button label="0">最大值</el-radio-button>
            <el-radio-button label="1">最小值</el-radio-button>
            <el-radio-button label="2">平均值</el-radio-button>
            <el-radio-button label="3">合格率</el-radio-button>
          </el-radio-group>
        </div> -->

        <div class="typeChart_1" id="typeChart_1" v-if="period == 2"></div>
        <div class="typeChart_2" id="typeChart_2" v-if="chart2Show && period == 2"></div>
      </div>
      <div style="clear: both"></div>
      <pavingTemperature
        v-if="period == 0"
        :activeIndex2Code="activeIndex2"
        :pavingQualityTemperatureData="pavingQualityTemperatureData"
      />
    </div>

    <div class="traceCon" v-if="!typeShow" v-loading="listLoading">
      <pavingSpeed
        v-if="period == 1"
        :activeIndex2Code="activeIndex2"
        :pavingQualitySpeed="pavingQualitySpeed"
      />
      <pavingEfficiency
        v-if="period == 4"
        :workId="workId"
        :pavingEfficiencyData="pavingEfficiencyData"
        :activeIndex2Code="activeIndex2"
        @childFn="parentFn"
      />
      <pavingTrace
        v-if="period == 5"
        :workId="workId"
        :workName="workName"
        :activeIndex2Code="activeIndex2"
      />
    </div>

    <el-dialog
      width="1600px"
      custom-class="mapdialog"
      :title="dialogTitle"
      :visible.sync="dialogMapVisible"
    >
      <heatMap
        ref="heatmap"
        v-if="dialogMapVisible"
        :chartOption="chartOption"
        :contentShow="false"
      />
      <div class="loadingShow" v-if="loadingShow">加载中...</div>
    </el-dialog>
  </div>
</template>

<script>
// import './css/global.scss'
import RollLegend from "../../pages/quality/part/rollLegend";
import { unique, dateFormat } from "../../utils/commons";
import {
  getCloudMap,
  getHeatMap,
  pavingQualityTemperature,
  pavingQualitySpeed,
  pavingQualityEfficiency,
  getWorkQualityStatistics,
} from "../../utils/api";
import heatMap from "../../components/chart/heatMap";
import LeftList from "../../components/layout/leftListT";
import pavingSpeed from "../../pages/quality/part/workPanel/pavingSpeedT";
import pavingEfficiency from "../../pages/quality/part/workPanel/pavingEfficiencyT";
import pavingTrace from "../../pages/quality/part/workPanel/pavingTrace";
import pavingTemperature from "../../pages/quality/part/workPanel/pavingTemperatureT";
export default {
  name: "app",
  data() {
    return {
      period: "0",
      periodNum: "0",
      duration: "",
      startDate: "",
      endDate: "",
      typeShow: true,
      activeIndex2: -1,
      pavingQualitySpeed: {},
      pavingEfficiencyData: {},
      dialogMapVisible: false,
      chartOption: {},
      chartOptionG: {},

      imageUrl: "",
      rnImageUrl: "", //碾压遍数图
      icvImageUrl: "", //压实度图
      rollingTemperatureImageUrl: "", //碾压温度图
      pavingTemperatureImageUrl: "", //摊铺温度图
      elevationImageUrl: "", //摊铺高程图
      evennessImageUrl: "", //平整度
      pavingQualityTemperatureData: {},
      dialogTitle: "碾压遍数详情",
      loadingShow: true,
      leftData: "",
      keyMap: {},
      typeChart_1: "",
      typeChart_2: "",
      unitValue: "遍",
      dateShow: true,
      listLoading: false,
      srcList: [],
      modeCode: 0,
      chart2Show: true,
    };
  },
  props: {
    workId: {
      type: String,
      default: function () {
        return "10";
      },
    },
    workName: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  computed: {},
  created() {},
  mounted() {
    const echarts = require("echarts");
    this.typeChart_1 = echarts.init(document.getElementById("typeChart_1"));
    this.typeChart_2 = echarts.init(document.getElementById("typeChart_2"));
  },
  watch: {
    workId: {
      handler(newVal) {
        // this.getHeatMapFun(newVal, this.period, "", "");
        getCloudMap({ workId: newVal }).then((res) => {
          console.log(res);
          if (res.data.content == null) {
            this.imageUrl = "";
            this.rnImageUrl = "";
            this.icvImageUrl = "";
            this.rollingTemperatureImageUrl = "";
            this.pavingTemperatureImageUrl = "";
            this.elevationImageUrl = "";
            this.evennessImageUrl = "";
          } else {
            this.imageUrl = JSON.parse(
              JSON.stringify(res.data.content.info.pavingTemperatureImageUrl)
            );
            this.rnImageUrl = res.data.content.info.rnImageUrl;
            this.icvImageUrl = res.data.content.info.icvImageUrl;
            this.rollingTemperatureImageUrl =
              res.data.content.info.rollingTemperatureImageUrl;
            this.pavingTemperatureImageUrl =
              res.data.content.info.pavingTemperatureImageUrl;
            this.elevationImageUrl = res.data.content.info.elevationImageUrl;
            this.evennessImageUrl = res.data.content.info.evennessImageUrl;
          }
          this.srcList = [this.imageUrl];
        });
        this.periodChange(0);
        this.getHeatMapFun(this.workId, 3, this.startDate, this.endDate);
        this.pavingQualityTemperatureFun(this.workId);
      },
      deep: true,
    },
  },
  methods: {
    parentFn(payload) {
      this.modeCode = payload;
    },
    searchBtn() {
      if (this.period == 0) {
        this.getHeatMapFun(this.workId, 3, this.startDate, this.endDate);
        this.pavingQualityTemperatureFun(this.workId);
      } else if (this.period == 1) {
        this.listLoading = true;
        pavingQualitySpeed({
          workId: this.workId,
          startDate: this.startDate,
          endDate: this.endDate,
        }).then((res) => {
          this.pavingQualitySpeed = res.data.content;
          this.listLoading = false;
        });
      } else if (this.period == 4) {
        pavingQualityEfficiency({
          workId: this.workId,
          startDate: this.startDate,
          endDate: this.endDate,
          mode: this.modeCode,
        }).then((res) => {
          this.activeIndex2 = 2;
          setTimeout(() => {
            this.pavingEfficiencyData = res.data.content.info;
            this.listLoading = false;
          }, 1000);
        });
      }
    },
    periodNumChange(e) {
      if (e == 3) {
        this.unitValue = "%";
      } else {
        this.unitValue =
          this.period == "0"
            ? "遍"
            : this.period == "1"
            ? ""
            : this.period == "2"
            ? "℃"
            : "";
      }
      this.periodNum = e;
      this.pavingQualityTemperatureFun(this.workId);
    },
    periodChange(e) {
      console.log(e);
      this.period = e;
      if (e == 0 || e == "0") {
        this.typeShow = true;
        this.dateShow = true;
        this.imageUrl = this.pavingTemperatureImageUrl;
        this.dialogTitle = "摊铺温度详情";
        this.unitValue = "℃";
        this.activeIndex2 = -1;
        this.listLoading = true;
        this.pavingQualityTemperatureFun(this.workId);
      } else if (e == 1 || e == "1") {
        this.typeShow = false;
        this.listLoading = true;
        this.dateShow = true;

        this.unitValue = "";
        pavingQualitySpeed({
          workId: this.workId,
          startDate: this.startDate,
          endDate: this.endDate,
        }).then((res) => {
          this.activeIndex2 = 1;
          setTimeout(() => {
            this.pavingQualitySpeed = res.data.content;
            this.listLoading = false;
          }, 1000);
        });
      } else if (e == 2 || e == "2") {
        this.typeShow = true;
        this.dateShow = true;
        this.imageUrl = this.elevationImageUrl;
        this.dialogTitle = "摊铺高程详情";
        this.unitValue = "mm";
        this.activeIndex2 = -1;
        this.listLoading = true;
        this.getHeatMapFun(this.workId, 6, this.startDate, this.endDate);
        this.getWorkQualityStatisticsFun(this.workId, 6);
        // this.pavingQualityTemperatureFun(this.workId);
      } else if (e == 3 || e == "3") {
        this.typeShow = true;
        this.dateShow = true;
        this.imageUrl = this.evennessImageUrl;
        this.dialogTitle = "平整度详情";
        this.unitValue = "mm";
        this.activeIndex2 = -1;
        this.listLoading = true;
        this.getHeatMapFun(this.workId, 7, this.startDate, this.endDate);
        this.getWorkQualityStatisticsFun(this.workId, 7);
        // this.pavingQualityTemperatureFun(this.workId);
      } else if (e == 4 || e == "4") {
        this.typeShow = false;
        this.listLoading = true;
        this.dateShow = true;
        pavingQualityEfficiency({
          workId: this.workId,
          startDate: this.startDate,
          endDate: this.endDate,
          mode: 0,
        }).then((res) => {
          this.activeIndex2 = 2;
          setTimeout(() => {
            this.pavingEfficiencyData = res.data.content.info;
            this.listLoading = false;
          }, 1000);
        });
      } else if (e == 5 || e == "5") {
        this.typeShow = false;
        this.dateShow = false;
        this.activeIndex2 = 3;
      }
      // switch (e) {
      //   case "0":
      //     this.typeShow = true;
      //     this.dateShow = true
      //     this.imageUrl = this.pavingTemperatureImageUrl;
      //     this.dialogTitle = "摊铺温度详情";
      //     this.unitValue = "℃";
      //     this.activeIndex2 = -1
      //     break;
      //   case "1":
      //     // this.imageUrl = this.icvImageUrl;
      //     // this.dialogTitle = "压实度详情";
      //     this.typeShow = false;
      //     this.listLoading = true
      //     this.dateShow = true
      //     this.activeIndex2 = 1
      //     this.unitValue = "";
      //     pavingQualitySpeed({
      //       workId: this.workId,
      //       startDate: this.startDate,
      //       endDate: this.endDate
      //     }).then(res=>{
      //       this.pavingQualitySpeed = res.data.content
      //       this.listLoading = false
      //     })
      //     break;
      //   case "2":
      //     // this.imageUrl = this.rollingTemperatureImageUrl;
      //     // this.dialogTitle = "碾压温度详情";
      //     // this.unitValue = "℃";
      //     this.typeShow = false;
      //     this.listLoading = true
      //     this.dateShow = true
      //       pavingQualityEfficiency({
      //       workId: this.workId,
      //       startDate: this.startDate,
      //       endDate: this.endDate
      //     }).then(res=>{
      //       this.pavingEfficiencyData = res.data.content.info
      //       this.activeIndex2 = 2
      //       this.listLoading = false
      //     })

      //     break;
      //   case "3":
      //     this.typeShow = false;
      //     this.dateShow = false
      //     this.activeIndex2 = 3
      //     break;
      // }
      if (e == 0) {
        this.getHeatMapFun(this.workId, 3, this.startDate, this.endDate);
        this.pavingQualityTemperatureFun(this.workId);
      }
      this.srcList = [this.imageUrl];
    },
    showDetail() {
      this.dialogMapVisible = true;
      this.loadingShow = true;
      let oriChartOption = JSON.parse(JSON.stringify(this.chartOptionG));
      this.chartOption = {};
      setTimeout(() => {
        this.chartOption = oriChartOption;
        this.loadingShow = false;
      }, 500);
      //   this.getHeatMapFun(
      //     this.workId,
      //     this.period,
      //     this.startDate,
      //     this.endDate
      //   );
    },
    dateChange(e) {
      console.log(e);
      if (e == null) {
        this.startDate = "";
        this.endDate = "";
      } else {
        this.startDate = dateFormat(e[0], "YYYY-MM-DD");
        this.endDate = dateFormat(e[1], "YYYY-MM-DD");
      }
    },
    //获取数据分析  摊铺温度
    pavingQualityTemperatureFun(id) {
      let params = {
        workId: id,
      };
      pavingQualityTemperature(params).then((res) => {
        console.log(res);
        this.pavingQualityTemperatureData = res.data.content;
        this.listLoading = false;
      });
    },
    //获取数据分析  摊铺高程
    getWorkQualityStatisticsFun(id, type) {
      let params = {
        workId: id,
        type: type,
      };
      getWorkQualityStatistics(params).then((res) => {
        console.log(res);
        let list = res.data.content.info.analyseData;
        // list = list.concat(list)
        this.chart2Show = list.length > 1 ? true : false;
        for (let i = 0; i < list.length; i++) {
          let equipCode = list[i].equipCode;
          let getArr = list[i].data;
          let xData_1 = [];
          let xData_2 = [];
          // let xData_3 = [];
          // let xData_4 = [];
          let xAxisData = [];
          for (let n = 0; n < getArr.length; n++) {
            xAxisData.push(getArr[n][0]);
            xData_1.push(getArr[n][5]);
            xData_2.push(getArr[n][6]);
            // xData_3.push(getArr[n][3]);
            // xData_4.push(getArr[n][4]);
          }
          let option = {
            color:['#F56C6C','#00FF00','#FFD700','#FF7F50'],
            legend: {
              data: [equipCode + '左高程差',equipCode + '右高程差'],
              // itemStyle:{
              //   color:['#ff0000','#ff0000','#ff0000','#ff0000']
              // }
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            grid: {
              left: 30,
              right: 30,
              top: 30,
              bottom: 35,
            },
            xAxis: {
              type: "category",
              data: xAxisData,
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "#878787",
                fontSize: 10,
              },
              axisLine: {
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
            yAxis: {
              type: "value",
              name: 'mm',
              nameTextStyle: {
                color: "#878787",
                fontSize: 13,
              },
              // interval: '',
              splitLine: {
                show: false,
                lineStyle: {
                  color: ["#F56C6C"],
                },
              },
              axisLabel: {
                color: "#878787",
                fontSize: 10,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: 70,
                end: 100,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "0",
                borderColor: "#F56C6C",
                fillerColor: "#F56C6C",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: [
              {
                data: xData_1,
                type: "line",
                name: equipCode + '左高程差',
                symbol:'none',
                // itemStyle: {
                //   normal: {
                //     lineStyle: {
                //       color: "#F56C6C",
                //     },
                //   },
                // },
              },{
                data: xData_2,
                type: "line",
                name: equipCode + '右高程差',
                symbol:'none',
                // itemStyle: {
                //   normal: {
                //     lineStyle: {
                //       color: "#00FF00",
                //     },
                //   },
                // },
              },
              // {
              //   data: xData_3,
              //   type: "line",
              //   name: equipCode + '右',
              //   symbol:'none',
              //   // itemStyle: {
              //   //   normal: {
              //   //     lineStyle: {
              //   //       color: "#FFD700",
              //   //     },
              //   //   },
              //   // },
              // },{
              //   data: xData_4,
              //   type: "line",
              //   name: equipCode + '右设计高程',
              //   symbol:'none',
              //   // itemStyle: {
              //   //   normal: {
              //   //     lineStyle: {
              //   //       color: "#FF7F50",
              //   //     },
              //   //   },
              //   // },
              // },
            ],
          };
          if(i == 0){
            const echarts = require("echarts");
            this.typeChart_1 = echarts.init(document.getElementById("typeChart_1"));
            this.typeChart_1.clear();
            this.typeChart_1.setOption(option);
          }else{
            const echarts = require("echarts");
            this.typeChart_2 = echarts.init(document.getElementById("typeChart_2"));
            this.typeChart_2.clear();
            this.typeChart_2.setOption(option);
          }
        }
      });
    },
    //获取热力图
    getHeatMapFun(id, t, s, e) {
      let params = {
        workId: id,
        type: t,
        startDate: s,
        endDate: e,
      };

      getHeatMap(params).then((r) => {
        console.log(r);
        let res = r.data.content.info;

        this.chartOptionG = this.getChartOption(r, t);
        let set = {};
        let getList = [];
        switch (t) {
          case "0":
            this.keyMap = {
              max: ["最高遍数"],
              min: ["最低遍数"],
              average: ["平均遍数"],
              standardDiff: ["标准差"],
              passRate: ["合格率"],
              overRate: ["过压率"],
              lackRate: ["欠压率"],
            };
            set.average =
              res.average == undefined ? null : res.average.toFixed(2);
            set.standardDiff =
              res.standardDiff == undefined
                ? null
                : res.standardDiff.toFixed(2);
            set.passRate =
              res.passRate == undefined
                ? null
                : (res.passRate * 100).toFixed(2) + "%";
            set.overRate =
              res.overRate == undefined
                ? null
                : (res.overRate * 100).toFixed(2) + "%";
            set.lackRate =
              res.lackRate == undefined
                ? null
                : (res.lackRate * 100).toFixed(2) + "%";
            set.max = res.max == undefined ? null : res.max;
            set.min = res.min == undefined ? null : res.min;
            this.leftData = set;
            break;
          case "1":
            this.keyMap = {
              max: ["最高遍数"],
              min: ["最低遍数"],
              average: ["平均遍数"],
              standardDiff: ["标准差"],
              passRate: ["合格率"],
              overRate: ["过压率"],
              lackRate: ["欠压率"],
            };
            set.average =
              res.average == undefined ? null : res.average.toFixed(2);
            set.standardDiff =
              res.standardDiff == undefined
                ? null
                : res.standardDiff.toFixed(2);
            set.passRate =
              res.passRate == undefined
                ? null
                : (res.passRate * 100).toFixed(2) + "%";
            set.overRate =
              res.overRate == undefined
                ? null
                : (res.overRate * 100).toFixed(2) + "%";
            set.lackRate =
              res.lackRate == undefined
                ? null
                : (res.lackRate * 100).toFixed(2) + "%";
            set.max = res.max == undefined ? null : res.max;
            set.min = res.min == undefined ? null : res.min;
            this.leftData = set;
            break;
          case 3:
            this.keyMap = {
              max: ["最高温度"],
              min: ["最低温度"],
              average: ["平均遍数"],
              standardDiff: ["标准差"],
              passRate: ["合格率"],
            };
            set.average =
              res.average == undefined ? null : res.average.toFixed(2) + "℃";
            set.standardDiff =
              res.standardDiff == undefined
                ? null
                : res.standardDiff.toFixed(2);
            set.passRate =
              res.passRate == undefined
                ? null
                : (res.passRate * 100).toFixed(2) + "%";
            // set.overRate =
            //   res.overRate == undefined
            //     ? null
            //     : (res.overRate * 100).toFixed(2) + "%";
            // set.lackRate =
            //   res.lackRate == undefined
            //     ? null
            //     : (res.lackRate * 100).toFixed(2) + "%";
            set.max = res.max == undefined ? null : res.max;
            set.min = res.min == undefined ? null : res.min;
            this.leftData = set;
            console.log(this.leftData);
            break;
          case 6:
            this.keyMap = {
              equipCode: ['设备编码'],
              leftPassRate: ["左侧合格率(±0.005m以内)"],
              leftPassAverage: ["左侧合格平均值"],
              leftExpectAverage: ["左侧异常平均值"],
              rightPassRate: ["右侧合格率(±0.005m以内)"],
              rightPassAverage: ["右侧合格平均值"],
              rightExpectAverage: ["右侧异常平均值"],
            };
            getList = JSON.parse(JSON.stringify(res.analyseData));
            for (let i = 0; i < getList.length; i++) {
              getList[i].leftPassRate = getList[i].leftPassRate + "%";
              getList[i].rightPassRate = getList[i].rightPassRate + "%";
              // getList[i].equipCode = getList[i].equipCode;
            }
            this.leftData = getList

            // this.leftData = res.analyseData
            console.log(this.leftData);
            break;
          case 7:
            this.keyMap = {
              equipCode: ['设备编码'],
              leftEveStdDev: ["左侧连续平整度"],
              rightEveStdDev: ["右侧连续平整度"],
            };
            getList = JSON.parse(JSON.stringify(res.analyseData));
            this.leftData = getList

            // this.leftData = res.analyseData
            console.log(this.leftData);
            break;
        }

        // let oriChartOption = JSON.parse(JSON.stringify(this.chartOptionG));
        // this.chartOption = {};
        // setTimeout(() => {
        //   this.chartOption = oriChartOption;
        //   this.loadingShow = false;
        // }, 500);
      });
    },
    getChartOption(res, t) {
      let colorBox = [];
      let colorList = [];
      let keys = [];
      let setArr = [];
      if (t == "3") {
        colorBox = JSON.parse(
          JSON.stringify(this.$store.state.pavColorArr)
        ).reverse();
        colorList = this.$store.state.pavColor;

        keys = Object.keys(colorList);
        for (let i = 0; i < keys.length; i++) {
          setArr.push({
            min: i == 0 ? 0 : keys[i - 1] * 1,
            max: keys[i] * 1,
          });
        }
        setArr[setArr.length - 1].max = 200;
      } else if (t == "6") {
        colorBox = JSON.parse(
          JSON.stringify(this.$store.state.elevationColorArr)
        ).reverse();
        colorList = this.$store.state.elevationColor;

        keys = Object.keys(colorList);
        for (let i = 0; i < keys.length; i++) {
          setArr.push({
            min: i == 0 ? "0" : keys[i - 1] * 1,
            max: keys[i] * 1,
          });
        }
        setArr[setArr.length - 1].max = 200;
        console.log(setArr);
      } else if (t == "7") {
        colorBox = JSON.parse(
          JSON.stringify(this.$store.state.evennessColorArr)
        ).reverse();
        colorList = this.$store.state.evennessColor;

        keys = Object.keys(colorList);
        for (let i = 0; i < keys.length; i++) {
          setArr.push({
            min: i == 0 ? "0" : keys[i - 1] * 1,
            max: keys[i] * 1,
          });
        }
        setArr[setArr.length - 1].max = 200;
      }

      let xAxisData = [];
      let dataG = [];
      if (t == "6" || t == "7") {
        dataG = res.data.content.info.hotData;
      } else {
        dataG = res.data.content.info.data;
      }
      xAxisData = dataG.map((item) => item[0]);
      let yAxisData = this.$store.state.roadWidth;
      console.log(xAxisData);
      console.log(yAxisData);

      let xAxisObj = {};
      xAxisData = unique(xAxisData);
      for (let i = 0; i < xAxisData.length; i++) {
        xAxisObj[xAxisData[i]] = i;
      }
      let data = [];
      const dataMap = {};
      dataG.map((item) => {
        const y = Math.floor(Math.random() * 6);
        dataMap[`${item[0]}_${y}`] = Math.ceil(Math.random() * 20);
      });
      let code = this.$store.state.deviationUnit;
      for (let i = 0; i < dataG.length; i++) {
        let arr = [
          xAxisObj[dataG[i][0]],
          (dataG[i][1] * 10) / (code * 10),
          dataG[i][2],
        ];
        data.push(arr);
      }
      console.log(data);
      let option = {
        visualMap: {
          type: "piecewise",
          min: 0,
          max: 100,
          calculable: true,
          realtime: false,
          orient: "horizontal",
          left: "center",
          bottom: "15%",
          show: false,
          pieces: setArr,
          color: colorBox,
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          splitArea: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            data: yAxisData,
            splitArea: {
              show: true,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              lineStyle: {
                color: "#878787",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#878787",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "",
            type: "heatmap",
            data: data,
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
          // {
          //   type: 'line',
          //   data: [['K00+007.51', '11'], ['K00+117', '11'], ['K00+168.3', '2'],['K00+007.51', '2'],['K00+007.51', '11']],
          //   lineStyle:{
          //     color:['#ff0'],
          //     width:2
          //   }

          // }
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            realtime: true,
            start: 0,
            end: 100,
            handleSize: "10%",
            height: 10,
            handleStyle: {
              borderWidth: 2,
            },
            bottom: "10%",
          },
          {
            type: "inside",
            xAxisIndex: [0],
          },
          {
            type: "slider",
            yAxisIndex: [0],
            show: false,
            zoomLock: true,
          },
        ],
      };
      return option;
    },
  },
  components: {
    heatMap,
    LeftList,
    pavingSpeed,
    pavingEfficiency,
    pavingTrace,
    pavingTemperature,
    RollLegend,
  },
};
</script>
<style lang="scss">
.mapdialog {
  width: 1520px !important;
  position: relative;
  .el-dialog__header {
    width: 1515px !important;
  }
  .el-dialog__body {
    width: 1515px !important;
    height: 520px !important;
  }
  .loadingShow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
<style lang="scss" scoped="">
.qualityContain {
  width: 100%;
  height: auto;
  //   min-height: 1500px;
  padding-top: 23px;
  padding-bottom: 24px;
  .typeCon {
    width: 100%;
    height: 59px;
  }
  .traceCon {
    width: 100%;
    height: 600px;
    margin-top: 16px;
  }
  .timeContain {
    width: 100%;
    height: 40px;
  }
  .searchBtn {
    margin-left: 24px;
  }
  .blockHeader {
    width: 100%;
    height: 58px;
    position: relative;
    .redBlock {
      height: 18px;
      width: 4px;
      position: absolute;
      background-color: #e96b5a;
      top: 19px;
      left: 0px;
    }
    .headerText {
      height: 16px;
      line-height: 16px;
      color: #222222;
      display: inline-block;
      position: absolute;
      top: 21px;
      left: 14px;
      font-weight: 500;
      font-size: 16px;
    }
  }
  .imgContent {
    width: 100%;
    height: 320px;
    overflow-y: scroll;
    position: relative;
    // background: rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.05);
    .checkDetail {
      width: 80px;
      height: 30px;
      // line-height: 30px;
      font-size: 14px;
      text-align: center;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      z-index: 99;
    }
    img {
      width: 100%;
      cursor: pointer;
    }
  }
  .infoContain {
    width: 100%;
    height: auto;
    min-height: 500px;
    .infoL {
      width: 456px;
      height: auto;
      float: left;
    }
    .infoR {
      width: 1344px;
      height: auto;
      float: left;
      margin-left: 24px;
      position: relative;
      .typeChart_1 {
        width: 100%;
        height: 224px;
        margin-bottom: 36px;
      }
      .typeChart_2 {
        width: 100%;
        height: 224px;
      }
    }
  }
}
.rollLegend {
  position: absolute;
  bottom: 20px;
  left: 0px;
  z-index: 1000;
}
</style>